export default "__VITE_ASSET__C3_Q1R1r__"